import '../../apps/b2b-ui/less/main.less';

// IMPORTANT: Must import @angular/compiler BEFORE any module that loads
// @angular/common (e.g. through HttpClient). The legacy require.context below
// eagerly loads b2b-ui which, via the AuthenticationService re-export, pulls
// in @angular/common and would otherwise fail with NG0202 / JIT compiler
// missing.
import '@angular/compiler';

import './legacy';

// Import the AngularJS app module to register all AngularJS components
// This must be imported BEFORE the hybrid bootstrap
import acme from '@b2b-ui';
import { initDevTools } from '@acme/b2b/devtools/bootstrap';

// Import hybrid bootstrap for Angular + AngularJS
import { bootstrapHybrid } from '@ng/main.hybrid';

(async () => {
  // Redirect root URL to /login before any routing code runs.
  // UIRouter sees /login from the start, avoiding the IGNORED initial transition.
  if (window.location.pathname === '/') {
    window.history.replaceState(null, '', '/login');
  }

  try {
    const resp = await fetch('/v2/api/client-config');
    const config = await resp.json();
    window.LL_API_KEY = config.lunchLitely?.apiKey;
    window.CONFIG.lunchLitely.apiKey = window.LL_API_KEY;
  } catch (e) {
    console.error('Failed to load client-config.json', e);
  }

  bootstrapHybrid(acme);
  initDevTools();
})();
